var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function calcPercentDifference(part, total) {
  var precision = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  return Number((100 * (1 - part / total)).toFixed(precision));
}
__name(calcPercentDifference, "calcPercentDifference");
export {
  calcPercentDifference
};
